import { Component, OnInit,OnDestroy,  ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'app-pesquisar',
  templateUrl: './pesquisar.component.html',
  styleUrls: ['./pesquisar.component.css']
})
export class PesquisarComponent implements OnInit, OnDestroy {
  @ViewChild("meuInputSearch") meuInputSearch: ElementRef;
  hideCL: boolean = false;
  inputsearch: any = '';
  mBusca: boolean = false;
  opBusca: any = '';
  listaCidades: any[] = [];
  listaUF: any[] = [];
  ufSelecionado: any = '';
  showDDC: any = false;
  qUF: any = '';
  qCidade: any = '';
  myControl = new FormControl();
  myControl2 = new FormControl();
  filteredOptions: Observable<string[]>;
  filteredOptions2: Observable<string[]>;
  ufSelecionadoN: any = '';
  cidadeSelecionadaN: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }

  ngOnInit() {

    
    this.hideCL = false;
    this.tmaService.eventoFS(true);
    this.opBusca = this.route.snapshot.paramMap.get('tipopesquisa');
    
    if(this.opBusca != 'pessoas'){
      //necessário locais, check se ls locais existe
      if(!this.tmaService.gBackBusca){
        if (localStorage.getItem("tmsGeoSearch") !== null) {
          var dadosGS = [];
          dadosGS = JSON.parse(localStorage.getItem('tmsGeoSearch'));
          this.router.navigate(['listar/' + this.opBusca + '/all/' +  dadosGS['uf'] + '/' + dadosGS['cidade']], {replaceUrl: true});
        }
        else{
          this.tmaService.getJsonBR("")
          .subscribe((qRes) =>{
            console.log(qRes);
            this.hideCL = true;
            this.listaUF = qRes['estados'];
            this.filteredOptions = this.myControl.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          })
        }
      }
      else{
        this.tmaService.getJsonBR("")
          .subscribe((qRes) =>{
            console.log(qRes);
            this.hideCL = true;
            this.listaUF = qRes['estados'];
            this.filteredOptions = this.myControl.valueChanges
            .pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          })
      }
      
    }
    else{
      this.hideCL = true;
    }

    //this.listaUF.push({uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' },{uf: 'SP' });
    //this.listaCidades.push({nome: 'Campinas'}, {nome: 'Hortolândia'}, {nome: 'Sumaré'});
    
  }

  ngAfterViewInit() {
    if(this.opBusca == 'pessoas'){
      this.meuInputSearch.nativeElement.focus();
    }
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaUF.filter(option => option.id.toLowerCase().includes(filterValue));
  }

  private _filter2(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaCidades.filter(option => option.cidade.toLowerCase().includes(filterValue));
  }

  digitando(textoBusca: any) :void{

  }

  changeUF() :void{
    console.log("alterou");
    this.listaCidades = [];
    console.log(this.qUF);
    this.hideCL = false;
    //realizar busca no servidor
    this.tmaService.getJsonUF(this.qUF)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.listaCidades = qRes['cidades'];
      this.hideCL = true;
    })
    
    //this.listaCidades = 
    this.showDDC = true;
  }
  changeUFn(siglaUF: any) :void{
    this.hideCL = false;
    this.showDDC = true;
    console.log("foi");
    this.tmaService.getJsonUF(siglaUF)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.listaCidades = qRes['cidades'];
      
      this.cidadeSelecionadaN = '';
      
      this.filteredOptions2 = this.myControl2.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter2(value))
      );
      this.hideCL = true;
    })
  }
  voltar() :void{
    //this._location.back();
    this.router.navigate(['/pesquisar']);
  }

  pesquisar() :void{
    //{replaceUrl: true}
    this.tmaService.tempPesquisaIdxL = 0;
    this.tmaService.tempPesquisaIdxG = 0;
    this.tmaService.tempPessoasL = [];
    this.tmaService.tempPessoasG = [];
    this.tmaService.tempTermo = '';
    this.router.navigate(['/resultados/' + this.inputsearch]);
  }
  goPesquisar() :void{
     if(this.qUF == ''){
      const ufNulo = this.dialog.open(AlertaSimplesDialog, {
        width: '250px',
        data: {textoAlerta: "Você precisa escolher um estado para continuar"}
       });
       return ;
     }

     if(this.qCidade == ''){
      const cidadeNula = this.dialog.open(AlertaSimplesDialog, {
        width: '250px',
        data: {textoAlerta: "Você precisa escolher uma cidade para continuar"}
       });
       return ;
     }
     this.hideCL = false;
     this.qCidade = this.modifiers(this.qCidade);
     console.log(this.modifiers(this.qCidade));
     this.router.navigate(['listar/' + this.opBusca + '/all/' +  this.qUF + '/' + this.qCidade], {replaceUrl: true});
  }

  goPesquisar2() :void{
    if(this.ufSelecionadoN == ''){
     const ufNulo = this.dialog.open(AlertaSimplesDialog, {
       width: '250px',
       data: {textoAlerta: "Você precisa escolher um estado para continuar"}
      });
      return ;
    }

    if(this.cidadeSelecionadaN == ''){
     const cidadeNula = this.dialog.open(AlertaSimplesDialog, {
       width: '250px',
       data: {textoAlerta: "Você precisa escolher uma cidade para continuar"}
      });
      return ;
    }
    this.hideCL = false;
    
    var cidadePesq = this.modifiers(this.cidadeSelecionadaN);
    console.log(this.cidadeSelecionadaN);
    console.log(this.modifiers(this.qCidade));
    localStorage.removeItem("tmsGeoSearch");
    localStorage["tmsGeoSearch"] = JSON.stringify({ uf: this.ufSelecionadoN, cidade: cidadePesq });
    this.router.navigate(['listar/' + this.opBusca + '/all/' +  this.ufSelecionadoN + '/' + cidadePesq], {replaceUrl: true});
 }

  modifiers(s: any): any{
    var r=s.toLowerCase();
    r = r.replace(new RegExp("\\s", 'g'),"-");
    r = r.replace(new RegExp("[àáâãäå]", 'g'),"a");
    r = r.replace(new RegExp("æ", 'g'),"ae");
    r = r.replace(new RegExp("ç", 'g'),"c");
    r = r.replace(new RegExp("[èéêë]", 'g'),"e");
    r = r.replace(new RegExp("[ìíîï]", 'g'),"i");
    r = r.replace(new RegExp("ñ", 'g'),"n");                            
    r = r.replace(new RegExp("[òóôõö]", 'g'),"o");
    r = r.replace(new RegExp("œ", 'g'),"oe");
    r = r.replace(new RegExp("[ùúûü]", 'g'),"u");
    r = r.replace(new RegExp("[ýÿ]", 'g'),"y");
    r = r.replace(new RegExp("\\W", 'g'),"-");
    return r;
};


}
